import { Box, ChakraProps } from "@chakra-ui/react";

import Node from "./Node";
import { TreeNode } from "./AccountPlanTree";

interface NodeListProps extends ChakraProps {
  parent?: TreeNode | undefined;
  nodelist: TreeNode[];
  edit?: boolean;
  tenant?: string;
}

export default function NodeList({
  parent,
  nodelist,
  edit,
  tenant,
  ...props
}: NodeListProps) {
  return (
    <>
      {nodelist?.map?.((node: TreeNode) => (
        <Box key={node?.id ?? node?.key} ml={4} {...props}>
          <Node tenant={tenant} parent={parent} node={node} edit={edit} />
          {node?.items && (
            <NodeList
              tenant={tenant}
              parent={node}
              nodelist={node.items}
              edit={edit}
            />
          )}
        </Box>
      ))}
    </>
  );
}
